import type { ProFieldValueEnumType } from '@ant-design/pro-components';

export enum TagBizType {
  App = 1,
}

export const TAG_BIZ_TYPE_ENUM: ProFieldValueEnumType = {
  [TagBizType.App]: { text: '应用' },
};

export { YES_NO_STATUS_ENUM as TAG_STATUS_ENUM } from '@/constants/yesNo';
